import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styles from './PrintLink.module.css';

export default function PrintLink({ onClick }) {
    const activeProfile = useSelector(state => state.app.activeProfile);
    const productSelection = useSelector(state => state.app.productSelection);
    const roomscene = useSelector(state => state.app.roomscene);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }

        // Build query parameters
        const params = new URLSearchParams();
        
        if (activeProfile && activeProfile.id) {
            params.append('profile', activeProfile.id);
        }
        
        if (productSelection && productSelection.length > 0) {
            params.append('products', productSelection.join(','));
        }

        if (roomscene) {
            params.append('room', roomscene);
        }

        const queryString = params.toString();
        const url = queryString ? `/print.html?${queryString}` : '/print.html';
        
        window.open(url, '_blank');
    };

    return (
        <button className={styles.viewBtn} onClick={handleClick}>
            Print Design
        </button>
    );
}

PrintLink.propTypes = {
    onClick: PropTypes.func,
};

